import { Box } from '@mui/material';
import Footer from 'components/common/Footer';
import Navbar from 'components/common/navbar/Navbar';
import { ReactNode } from 'react';

interface NavbarLayoutProps {
  children: ReactNode;
  showNavbarProductSearch?: boolean;
}

export default function NavbarLayout({
  children,
  showNavbarProductSearch,
}: NavbarLayoutProps) {
  return (
    <Box>
      <Navbar showProductSearch={showNavbarProductSearch} />
      <Box
        sx={{
          position: 'relative',
          top: { xs: showNavbarProductSearch ? 112 : 56, sm: 64 },
        }}
      >
        {children}
      </Box>
      <Box sx={{ marginTop: 14 }}>
        <Footer />
      </Box>
    </Box>
  );
}
